import React, { useState, useEffect } from 'react';
import './Products.css';
import './AllSellStyles.css';
import './CommonStyles.css';
import { exportToCSV, exportToExcel, exportToPDF, printPage } from './exportUtils';
import apiService from '../../services/api';

const MsaTobaccoReport = () => {
    const [entriesPerPage1, setEntriesPerPage1] = useState(25);
    const [searchTerm1, setSearchTerm1] = useState('');
    const [showExportDropdown1, setShowExportDropdown1] = useState(false);

    const [entriesPerPage2, setEntriesPerPage2] = useState(25);
    const [searchTerm2, setSearchTerm2] = useState('');
    const [showExportDropdown2, setShowExportDropdown2] = useState(false);

    const [reportData, setReportData] = useState([]);
    const [reportHistory, setReportHistory] = useState([]);
    const [loadingData, setLoadingData] = useState(true);

    useEffect(() => {
        const fetchMsaReport = async () => {
            try {
                setLoadingData(true);
                const [dataRes, historyRes] = await Promise.all([
                    apiService.getMsaTobaccoData().catch(() => null),
                    apiService.getMsaTobaccoHistory().catch(() => null)
                ]);

                if (dataRes && (dataRes.data || Array.isArray(dataRes))) {
                    const list = Array.isArray(dataRes) ? dataRes : (dataRes.data || []);
                    setReportData(list);
                }
                if (historyRes && (historyRes.data || Array.isArray(historyRes))) {
                    const hist = Array.isArray(historyRes) ? historyRes : (historyRes.data || []);
                    setReportHistory(hist);
                }
            } catch (err) {
                /* fallback handled safely */
            } finally {
                setLoadingData(false);
            }
        };

        fetchMsaReport();
    }, []);

    const handleExport1 = (format) => {
        const headers = ['Invoice No.', 'Date', 'Product Name', 'Category', 'Quantity', 'Unit Price', 'Total', 'Tax', 'Total (Including of Tax)'];
        const rows = reportData.map(r => [
            r.invoiceNo || '',
            r.date || '',
            r.productName || '',
            r.category || '',
            r.qty || '0.00',
            r.unitPrice || '0.00',
            r.total || '0.00',
            r.tax || '0.00',
            r.totalIncTax || '0.00'
        ]);

        const title = 'MSA Tobacco Report';
        const filename = 'msa_tobacco_report';

        if (format === 'CSV') exportToCSV(headers, rows, filename);
        else if (format === 'Excel') exportToExcel(headers, rows, filename);
        else if (format === 'PDF') exportToPDF(title, headers, rows, filename);
        else if (format === 'Print') printPage();

        setShowExportDropdown1(false);
    };

    const handleExport2 = (format) => {
        const headers = ['Message Date', 'Report Type', 'Filters', 'Created By', 'Action'];
        const rows = reportHistory.map(r => [
            r.messageDate || '',
            r.reportType || '',
            r.filters || '',
            r.createdBy || '',
            r.action || ''
        ]);

        const title = 'MSA Tobacco Report History';
        const filename = 'msa_tobacco_report_history';

        if (format === 'CSV') exportToCSV(headers, rows, filename);
        else if (format === 'Excel') exportToExcel(headers, rows, filename);
        else if (format === 'PDF') exportToPDF(title, headers, rows, filename);
        else if (format === 'Print') printPage();

        setShowExportDropdown2(false);
    };

    return (
        <div style={{ paddingTop: '0.5rem', display: 'flex', flexDirection: 'column', gap: '1.5rem' }}>

            {/* ── Top Card: MSA Tobacco Report ── */}
            <div style={{
                background: 'var(--etpos-card, #fff)',
                border: '1px solid var(--etpos-border, #e2e8f0)',
                borderRadius: '10px',
                overflow: 'hidden',
                boxShadow: '0 1px 3px rgba(0,0,0,0.06)'
            }}>
                {/* Header with Title and Buttons */}
                <div style={{
                    display: 'flex', justifyContent: 'space-between', alignItems: 'center',
                    padding: '1.25rem 1.5rem', borderBottom: '1px solid var(--etpos-border, #e2e8f0)'
                }}>
                    <h2 style={{ fontSize: '1.1rem', fontWeight: '500', color: 'var(--etpos-text, #475569)', margin: 0 }}>
                        MSA Tobacco Report
                    </h2>
                    <div style={{ display: 'flex', gap: '0.5rem' }}>
                        <button style={{
                            background: '#3b82f6', color: 'white', border: 'none', borderRadius: '4px',
                            padding: '0.5rem 1rem', fontSize: '0.85rem', cursor: 'pointer',
                            display: 'flex', alignItems: 'center', gap: '0.5rem'
                        }}>
                            <i className="fa fa-download" /> Export to Excel
                        </button>
                        <button style={{
                            background: '#22c55e', color: 'white', border: 'none', borderRadius: '4px',
                            padding: '0.5rem 1rem', fontSize: '0.85rem', cursor: 'pointer',
                            display: 'flex', alignItems: 'center', gap: '0.5rem'
                        }}>
                            <i className="fa fa-envelope" /> Email Report
                        </button>
                    </div>
                </div>

                {/* Table controls */}
                <div className="table-controls" style={{ borderBottom: '1px solid var(--etpos-border, #e2e8f0)', padding: '1rem 1.25rem' }}>
                    <div className="table-controls-left">
                        <div className="entries-select" style={{ color: 'var(--etpos-text, #334155)' }}>
                            <span>Show</span>
                            <select value={entriesPerPage1} onChange={e => setEntriesPerPage1(Number(e.target.value))} style={{ background: 'var(--etpos-card, #fff)', color: 'var(--etpos-text, #334155)', border: '1px solid var(--etpos-border, #cbd5e1)' }}>
                                <option value={25}>25</option>
                                <option value={50}>50</option>
                                <option value={100}>100</option>
                            </select>
                            <span>entries</span>
                        </div>
                    </div>

                    <div className="table-controls-right">
                        {/* Single Export dropdown */}
                        <div className="export-dropdown-container" style={{ position: 'relative' }}>
                            <button
                                className="export-btn"
                                onClick={() => setShowExportDropdown1(!showExportDropdown1)}
                                style={{
                                    display: 'flex', alignItems: 'center', gap: '0.4rem',
                                    padding: '0.4rem 0.8rem', border: '1px solid var(--etpos-border, #e2e8f0)',
                                    borderRadius: '6px', background: 'var(--etpos-card, #fff)', cursor: 'pointer',
                                    fontSize: '0.85rem', color: 'var(--etpos-text, #334155)'
                                }}
                            >
                                <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                                    <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4" />
                                    <polyline points="7 10 12 15 17 10" />
                                    <line x1="12" y1="15" x2="12" y2="3" />
                                </svg>
                                Export ▾
                            </button>
                            {showExportDropdown1 && (
                                <div className="export-dropdown-menu" style={{
                                    position: 'absolute', top: '100%', right: 0, marginTop: '0.25rem',
                                    background: 'var(--etpos-card, #fff)', border: '1px solid var(--etpos-border, #e2e8f0)', borderRadius: '6px',
                                    boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.1)', zIndex: 10, minWidth: '160px'
                                }}>
                                    {[
                                        { icon: 'fa-file-excel-o', label: 'Export CSV', action: () => handleExport1('CSV') },
                                        { icon: 'fa-file-excel-o', label: 'Export Excel', action: () => handleExport1('Excel') },
                                        { icon: 'fa-print', label: 'Print', action: () => handleExport1('Print') },
                                        { icon: 'fa-table', label: 'Column visibility' },
                                        { icon: 'fa-file-pdf-o', label: 'Export PDF', action: () => handleExport1('PDF') },
                                    ].map((item, i) => (
                                        <button
                                            key={i}
                                            onClick={() => { if (item.action) item.action(); else setShowExportDropdown1(false); }}
                                            style={{
                                                display: 'flex', alignItems: 'center', gap: '0.5rem',
                                                width: '100%', padding: '0.5rem 1rem', border: 'none',
                                                background: 'none', textAlign: 'left', cursor: 'pointer',
                                                fontSize: '0.8125rem', color: 'var(--etpos-text, #475569)'
                                            }}
                                            onMouseEnter={e => e.currentTarget.style.backgroundColor = 'var(--etpos-border, #f1f5f9)'}
                                            onMouseLeave={e => e.currentTarget.style.backgroundColor = 'transparent'}
                                        >
                                            <i className={`fa ${item.icon}`} style={{ width: '14px', textAlign: 'center' }} />
                                            {item.label}
                                        </button>
                                    ))}
                                </div>
                            )}
                        </div>

                        {/* Search */}
                        <input
                            type="text"
                            placeholder="Search ..."
                            value={searchTerm1}
                            onChange={e => setSearchTerm1(e.target.value)}
                            style={{
                                padding: '0.4rem 0.75rem',
                                border: '1px solid var(--etpos-border, #e2e8f0)',
                                borderRadius: '6px',
                                fontSize: '0.8125rem',
                                outline: 'none',
                                width: '180px',
                                background: 'var(--etpos-card, #fff)',
                                color: 'var(--etpos-text, #334155)'
                            }}
                        />
                    </div>
                </div>

                {/* Table 1 */}
                <div style={{ overflowX: 'auto' }}>
                    <table className="products-table" style={{ width: '100%', borderCollapse: 'collapse', textAlign: 'left' }}>
                        <thead>
                            <tr style={{ background: 'var(--etpos-card, #f8fafc)', borderBottom: '1px solid var(--etpos-border, #e2e8f0)' }}>
                                <th style={{ padding: '0.75rem 1rem', fontSize: '0.8125rem', color: 'var(--etpos-text, #1e293b)', fontWeight: '700' }}>Invoice No. <i className="fa fa-sort" style={{ color: 'var(--etpos-text-muted, #cbd5e1)', marginLeft: '4px' }} /></th>
                                <th style={{ padding: '0.75rem 1rem', fontSize: '0.8125rem', color: 'var(--etpos-text, #1e293b)', fontWeight: '700' }}>Date <i className="fa fa-sort" style={{ color: 'var(--etpos-text-muted, #cbd5e1)', marginLeft: '4px' }} /></th>
                                <th style={{ padding: '0.75rem 1rem', fontSize: '0.8125rem', color: 'var(--etpos-text, #1e293b)', fontWeight: '700' }}>Product Name <i className="fa fa-sort" style={{ color: 'var(--etpos-text-muted, #cbd5e1)', marginLeft: '4px' }} /></th>
                                <th style={{ padding: '0.75rem 1rem', fontSize: '0.8125rem', color: 'var(--etpos-text, #1e293b)', fontWeight: '700' }}>Category <i className="fa fa-sort" style={{ color: 'var(--etpos-text-muted, #cbd5e1)', marginLeft: '4px' }} /></th>
                                <th style={{ padding: '0.75rem 1rem', fontSize: '0.8125rem', color: 'var(--etpos-text, #1e293b)', fontWeight: '700' }}>Quantity <i className="fa fa-sort" style={{ color: 'var(--etpos-text-muted, #cbd5e1)', marginLeft: '4px' }} /></th>
                                <th style={{ padding: '0.75rem 1rem', fontSize: '0.8125rem', color: 'var(--etpos-text, #1e293b)', fontWeight: '700' }}>Unit Price <i className="fa fa-sort" style={{ color: 'var(--etpos-text-muted, #cbd5e1)', marginLeft: '4px' }} /></th>
                                <th style={{ padding: '0.75rem 1rem', fontSize: '0.8125rem', color: 'var(--etpos-text, #1e293b)', fontWeight: '700' }}>Total <i className="fa fa-sort" style={{ color: 'var(--etpos-text-muted, #cbd5e1)', marginLeft: '4px' }} /></th>
                                <th style={{ padding: '0.75rem 1rem', fontSize: '0.8125rem', color: 'var(--etpos-text, #1e293b)', fontWeight: '700' }}>Tax <i className="fa fa-sort" style={{ color: 'var(--etpos-text-muted, #cbd5e1)', marginLeft: '4px' }} /></th>
                                <th style={{ padding: '0.75rem 1rem', fontSize: '0.8125rem', color: 'var(--etpos-text, #1e293b)', fontWeight: '700' }}>Total (Including of Tax) <i className="fa fa-sort" style={{ color: 'var(--etpos-text-muted, #cbd5e1)', marginLeft: '4px' }} /></th>
                            </tr>
                        </thead>
                        <tbody>
                            {loadingData ? (
                                <tr>
                                    <td colSpan="9" style={{ padding: '2rem', textAlign: 'center', color: '#64748b' }}>
                                        Loading MSA Tobacco data...
                                    </td>
                                </tr>
                            ) : reportData.length === 0 ? (
                                <tr>
                                    <td colSpan="9" style={{ padding: '2rem', textAlign: 'center', color: '#64748b' }}>
                                        No MSA Tobacco sales found.
                                    </td>
                                </tr>
                            ) : (
                                reportData.map((row, idx) => (
                                    <tr key={idx} style={{ borderBottom: '1px solid var(--etpos-border, #f1f5f9)' }}>
                                        <td style={{ padding: '0.75rem 1rem', fontSize: '0.8125rem', color: 'var(--etpos-text, #475569)' }}>{row.invoiceNo}</td>
                                        <td style={{ padding: '0.75rem 1rem', fontSize: '0.8125rem', color: 'var(--etpos-text, #475569)' }}>{row.date}</td>
                                        <td style={{ padding: '0.75rem 1rem', fontSize: '0.8125rem', color: 'var(--etpos-text, #475569)' }}>{row.productName}</td>
                                        <td style={{ padding: '0.75rem 1rem', fontSize: '0.8125rem', color: 'var(--etpos-text, #475569)' }}>{row.category}</td>
                                        <td style={{ padding: '0.75rem 1rem', fontSize: '0.8125rem', color: 'var(--etpos-text, #475569)' }}>{row.qty}</td>
                                        <td style={{ padding: '0.75rem 1rem', fontSize: '0.8125rem', color: 'var(--etpos-text, #475569)' }}>{row.unitPrice}</td>
                                        <td style={{ padding: '0.75rem 1rem', fontSize: '0.8125rem', color: 'var(--etpos-text, #475569)' }}>{row.total}</td>
                                        <td style={{ padding: '0.75rem 1rem', fontSize: '0.8125rem', color: 'var(--etpos-text, #475569)' }}>{row.tax}</td>
                                        <td style={{ padding: '0.75rem 1rem', fontSize: '0.8125rem', color: 'var(--etpos-text, #475569)' }}>{row.totalIncTax}</td>
                                    </tr>
                                ))
                            )}
                        </tbody>
                    </table>
                </div>

                {/* Pagination */}
                <div className="pagination" style={{ padding: '0.85rem 1.25rem', borderTop: '1px solid var(--etpos-border, #e2e8f0)', borderBottom: '1px solid var(--etpos-border, #e2e8f0)' }}>
                    <div className="pagination-info" style={{ fontSize: '0.8125rem', color: 'var(--etpos-text, #334155)' }}>
                        Showing {reportData.length > 0 ? 1 : 0} to {reportData.length} of {reportData.length} entries
                    </div>
                </div>
            </div>

            {/* ── Bottom Card: Report History ── */}
            <div style={{
                background: 'var(--etpos-card, #fff)',
                border: '1px solid var(--etpos-border, #e2e8f0)',
                borderRadius: '10px',
                overflow: 'hidden',
                boxShadow: '0 1px 3px rgba(0,0,0,0.06)'
            }}>
                {/* Header with Title */}
                <div style={{ padding: '1.25rem 1.5rem', borderBottom: '1px solid var(--etpos-border, #e2e8f0)' }}>
                    <h2 style={{ fontSize: '1.1rem', fontWeight: '500', color: 'var(--etpos-text, #475569)', margin: 0 }}>
                        Report History
                    </h2>
                </div>

                {/* Table 2 */}
                <div style={{ overflowX: 'auto', paddingBottom: '0.5rem' }}>
                    <table className="products-table" style={{ width: '100%', borderCollapse: 'collapse', textAlign: 'left' }}>
                        <thead>
                            <tr style={{ background: 'var(--etpos-card, #f8fafc)', borderBottom: '1px solid var(--etpos-border, #e2e8f0)' }}>
                                <th style={{ padding: '0.75rem 1rem', fontSize: '0.8125rem', color: 'var(--etpos-text, #1e293b)', fontWeight: '700' }}>Message Date</th>
                                <th style={{ padding: '0.75rem 1rem', fontSize: '0.8125rem', color: 'var(--etpos-text, #1e293b)', fontWeight: '700' }}>Report Type</th>
                                <th style={{ padding: '0.75rem 1rem', fontSize: '0.8125rem', color: 'var(--etpos-text, #1e293b)', fontWeight: '700' }}>Filters</th>
                                <th style={{ padding: '0.75rem 1rem', fontSize: '0.8125rem', color: 'var(--etpos-text, #1e293b)', fontWeight: '700' }}>Created By</th>
                            </tr>
                        </thead>
                        <tbody>
                            {reportHistory.length > 0 ? (
                                reportHistory.map((row, idx) => (
                                    <tr key={idx} style={{ borderBottom: '1px solid var(--etpos-border, #f1f5f9)' }}>
                                        <td style={{ padding: '0.75rem 1rem', fontSize: '0.8125rem', color: 'var(--etpos-text, #475569)' }}>{row.messageDate}</td>
                                        <td style={{ padding: '0.75rem 1rem', fontSize: '0.8125rem', color: 'var(--etpos-text, #475569)' }}>{row.reportType}</td>
                                        <td style={{ padding: '0.75rem 1rem', fontSize: '0.8125rem', color: 'var(--etpos-text, #475569)' }}>{row.filters || 'None'}</td>
                                        <td style={{ padding: '0.75rem 1rem', fontSize: '0.8125rem', color: 'var(--etpos-text, #475569)' }}>{row.createdBy}</td>
                                    </tr>
                                ))
                            ) : (
                                <tr style={{ borderBottom: '1px solid var(--etpos-border, #f1f5f9)' }}>
                                    <td colSpan="4" style={{ padding: '1.5rem 1rem', textAlign: 'center', fontSize: '0.85rem', color: 'var(--etpos-text-muted, #64748b)' }}>
                                        No report history available.
                                    </td>
                                </tr>
                            )}
                        </tbody>
                    </table>
                </div>

                {/* Pagination */}
                <div className="pagination" style={{ padding: '0.85rem 1.25rem', borderTop: '1px solid var(--etpos-border, #e2e8f0)' }}>
                    <div className="pagination-info" style={{ fontSize: '0.8125rem', color: 'var(--etpos-text, #334155)' }}>
                        Showing 0 to 0 of 0 entries
                    </div>
                    <div className="pagination-controls">
                        <button className="page-btn disabled" style={{ background: 'var(--etpos-card, #fff)', color: 'var(--etpos-text-muted, #94a3b8)', border: '1px solid var(--etpos-border, #e2e8f0)' }}>Previous</button>
                        <button className="page-btn disabled" style={{ background: 'var(--etpos-card, #fff)', color: 'var(--etpos-text-muted, #94a3b8)', border: '1px solid var(--etpos-border, #e2e8f0)' }}>Next</button>
                    </div>
                </div>
            </div>

        </div>
    );
};

export default MsaTobaccoReport;
